export default __webpack_public_path__ + "static/media/review.322b2120.svg";